import { useEffect, useRef, useState } from 'react';
import api from '../services/api';

/**
 * Mode filter state that auto-defaults to "live" when global Master Chef live
 * trading is enabled. Falls back to `allValue` (the "all modes" sentinel) otherwise.
 *
 * The auto-default is applied at most once and never overrides an explicit
 * initial value (e.g. a `?mode=` deep link) or a manual user selection.
 *
 * @param {string} allValue        Value representing "all modes" ('' or 'all')
 * @param {string|null} lockedInitial  Explicit initial mode (locks out auto-default)
 * @returns {[string, (val: string) => void]}
 */
export default function useDefaultTradingMode(allValue = '', lockedInitial = null) {
  const hasLockedInitial = lockedInitial !== null && lockedInitial !== undefined && lockedInitial !== '';
  const [mode, setModeState] = useState(hasLockedInitial ? lockedInitial : allValue);
  const locked = useRef(hasLockedInitial);

  useEffect(() => {
    if (locked.current) return;
    let cancelled = false;
    api
      .get('/masterchef/dashboard')
      .then((r) => {
        if (cancelled || locked.current) return;
        if (r.data?.dryRun === false) {
          locked.current = true;
          setModeState('live');
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const setMode = (val) => {
    locked.current = true;
    setModeState(val);
  };

  return [mode, setMode];
}
